/* Shipping Protection — deferred add.
   The merchant sets the DEFAULT state (on/off) in the cart drawer settings.
   The toggle always shows; a shopper's explicit choice overrides the default and
   is remembered. Nothing is added to the cart while browsing — the protection
   product is added at the moment Checkout is pressed, so the slide cart stays clean. */
(function () {
  var KEY = 'sunni_sp_choice';           // 'on' | 'off' | absent (= use merchant default)
  var LEGACY = 'sunni_sp_off';           // previous boolean opt-out flag
  var busy = false, syncTimer = null;

  function root() { return document.querySelector('[data-protect-variant]'); }

  function merchantDefault() {
    var el = root();
    return el ? el.getAttribute('data-protect-default') === 'true' : false;
  }

  function choice() {
    try {
      var c = localStorage.getItem(KEY);
      if (c === 'on' || c === 'off') return c;
      if (localStorage.getItem(LEGACY) === '1') return 'off';   // migrate old flag
    } catch (e) {}
    return null;
  }

  function setChoice(v) { try { localStorage.setItem(KEY, v); localStorage.removeItem(LEGACY); } catch (e) {} }

  function isOn() {
    var c = choice();
    return c === null ? merchantDefault() : c === 'on';
  }

  function variantId() {
    var el = root();
    return el ? parseInt(el.getAttribute('data-protect-variant'), 10) : null;
  }

  function isProtection(it, vid) {
    return it.variant_id === vid || (it.properties && it.properties._shipping_protection);
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }

  function syncToggle() {
    var i = document.querySelector('[data-protect-toggle]');
    if (i) { i.checked = isOn(); i.disabled = false; }
  }
  function scheduleSync() { clearTimeout(syncTimer); syncTimer = setTimeout(syncToggle, 120); }

  // Toggle only records the shopper's choice — no cart mutation while browsing
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.hasAttribute || !input.hasAttribute('data-protect-toggle')) return;
    setChoice(input.checked ? 'on' : 'off');
  }, true);

  if (document.body) new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });

  // If a protection line is lingering (e.g. back from checkout), strip it
  function cleanup() {
    var vid = variantId();
    if (!vid || busy) { syncToggle(); return; }
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.find(function (it) { return isProtection(it, vid); });
        if (line) return post('/cart/change.js', { id: line.key, quantity: 0 });
      })
      .catch(function () {})
      .finally(function () { busy = false; syncToggle(); });
  }

  // Intercept checkout: add protection first if it's on, then continue
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart') === -1) return;
    var submitter = e.submitter;
    var isCheckout = (submitter && submitter.name === 'checkout') || !!form.querySelector('button[name="checkout"]');
    if (!isCheckout) return;
    var vid = variantId();
    if (!vid || !isOn()) return;                   // proceed normally, no protection
    e.preventDefault();
    var go = function () { window.location.href = '/checkout'; };
    post('/cart/add.js', { id: vid, quantity: 1, properties: { _shipping_protection: 'true' } }).then(go).catch(go);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanup);
  else cleanup();
})();
